import {
  Box, Typography, Chip, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, alpha, useTheme,
} from '@mui/material';

const STATUS_COLORS = {
  DRAFT: { label: 'Draft', color: '#607d8b' },
  IN_REVIEW: { label: 'In Review', color: '#2196f3' },
  PENDING_SIGNATURE: { label: 'Pending Signature', color: '#ff9800' },
  SIGNED: { label: 'Signed', color: '#4caf50' },
};

const UserContractsTab = ({ contracts }) => {
  const theme = useTheme();

  if (!contracts?.items?.length) {
    return <Typography variant="body2" sx={{ color: theme.palette.text.secondary, py: 3 }}>No contracts found.</Typography>;
  }

  return (
    <Box>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
        Showing {contracts.items.length} of {contracts.total} contracts
      </Typography>
      <TableContainer sx={{ borderRadius: '8px', border: `1px solid ${theme.palette.divider}` }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
              <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Role</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Comments</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Suggestions</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contracts.items.map((c, i) => {
              const sc = STATUS_COLORS[c.status] || { label: c.status, color: '#607d8b' };
              return (
                <TableRow key={c.id || i}>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, maxWidth: 250 }} noWrap>
                      {c.title || 'Untitled'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={sc.label}
                      size="small"
                      sx={{ fontWeight: 600, fontSize: '0.7rem', bgcolor: alpha(sc.color, 0.12), color: sc.color }}
                    />
                  </TableCell>
                  <TableCell><Typography variant="body2">{c.type || '—'}</Typography></TableCell>
                  <TableCell>
                    <Chip label={c.role} size="small" variant="outlined" sx={{ fontSize: '0.7rem', textTransform: 'capitalize' }} />
                  </TableCell>
                  <TableCell>{c.comment_count || 0}</TableCell>
                  <TableCell>{c.suggestion_count || 0}</TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {c.created_at ? new Date(c.created_at).toLocaleDateString() : '—'}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserContractsTab;
